export default __webpack_public_path__ + "static/media/Resources.94e8209d.svg";